export const INCIDENT_TYPE_API = (communityId: string) => `v1/incident-types/community/${communityId}`;
